import { LOGIN, LOGIN_ADMIN, SOCIETY_CONTROLLER } from "../../Routing/routes";
import webTokenStorer from "../webStorer";

export const logOut = () => {
    webTokenStorer.removeToken()
    window.location.href = SOCIETY_CONTROLLER + LOGIN;
}

export const logOut2 = () => {
    webTokenStorer.removeToken()
    window.location.href = LOGIN_ADMIN;
}
